module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a4451ef35d29c4997f7c8e837da8af44.svg";